<section class="custom-domain-success-container">
  <div class="title">You have successfully added your custom domain</div>
  <div class="domain-info">
    <div class="custom-domain-info-line">
      <div class="line-title">Current domain</div>
      <div class="line-value">{{ domain }}</div>
    </div>
    <div class="line"></div>
    <div class="custom-domain-info-line">
      <div class="line-title">Your client sites’ URL example</div>
      <div class="line-value"><span>{{ clientUrl }}</span>{{ domain }}</div>
    </div>
  </div>
  <div class="action-container">
    <button class="ds-btn-outline" (click)="activeService.close()"><span>Proceed</span></button>
  </div>
</section>
